var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isSplashActive)?_c('div',{staticClass:"splash"},[_c('img',{attrs:{"src":require("@/assets/splash.png")}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }